import {createApi} from "@reduxjs/toolkit/query/react";
import {Response} from "../../types/response/Response";
import {apiQueryV2} from "../utils/Extensions";
import {BranchDTO} from "../../types/branch/BranchDTO";


export const branchApi = createApi({
    reducerPath: "branch",
    baseQuery: apiQueryV2,
    tagTypes: ["branches"],
    endpoints: builder => ({
        getBranches: builder.query<Response<BranchDTO[]>, Partial<void>>({
            query: () => '/organizations',
            providesTags: ["branches"],
            extraOptions: {maxRetries: 3}
        })
    })
})

export const {
    useGetBranchesQuery,
    useLazyGetBranchesQuery
} = branchApi